import type { ApiErrorResponse } from '../types/site-api'

/** 兼容业务异常出口与 Laravel 校验响应，保留限流的专用提示。 */
export function getFeedbackErrorMessage(response?: ApiErrorResponse, status?: number): string {
  if (status === 429) return '提交过于频繁，请稍后再试。'
  return response?.error?.msg || response?.message || '提交失败，请稍后重试。'
}
